/**
 * Verse 이름·refresh 타이밍 헬퍼.
 */

/** preview env 면 `-preview` suffix 자동 부착. prod 면 그대로. */
export function resolveVerse(baseVerse: string, env: 'preview' | 'prod'): string {
  return env === 'preview' ? `${baseVerse}-preview` : baseVerse;
}

/** 게임 토큰 만료 5분 전에 재발급. */
export const REFRESH_SKEW_MS = 5 * 60_000;
/** Refresh delay floor — exp 이 이미 지났을 때 busy-loop 방지. */
export const MIN_REFRESH_DELAY_MS = 60_000;

/** 다음 refresh 까지 ms. (exp − skew, floored to MIN_REFRESH_DELAY_MS) */
export function msUntilRefresh(expMs: number, now: number = Date.now()): number {
  return Math.max(MIN_REFRESH_DELAY_MS, expMs - now - REFRESH_SKEW_MS);
}
